/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AddressRequest, AddressResponse } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiShippingAddressControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-shipping-address-controller-v-2
   * @name UpdateOrganisationShippingAddress
   * @request PUT:/api/v2/organisation/shipping-address/{shippingAddressId}
   */
  updateOrganisationShippingAddress = (
    shippingAddressId: string,
    data: AddressRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AddressResponse, any>({
      path: `/v2/organisation/shipping-address/${shippingAddressId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationShippingAddressPath =
    '/v2/organisation/shipping-address/${shippingAddressId}'
  static updateOrganisationShippingAddressMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-shipping-address-controller-v-2
   * @name DeleteOrganisationShippingAddress
   * @request DELETE:/api/v2/organisation/shipping-address/{shippingAddressId}
   */
  deleteOrganisationShippingAddress = (shippingAddressId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v2/organisation/shipping-address/${shippingAddressId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteOrganisationShippingAddressPath =
    '/v2/organisation/shipping-address/${shippingAddressId}'
  static deleteOrganisationShippingAddressMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-shipping-address-controller-v-2
   * @name GetOrganisationShippingAddresses
   * @request GET:/api/v2/organisation/shipping-address
   */
  getOrganisationShippingAddresses = (params: RequestParams = {}) =>
    this.http.request<AddressResponse[], any>({
      path: `/v2/organisation/shipping-address`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationShippingAddressesPath = '/v2/organisation/shipping-address'
  static getOrganisationShippingAddressesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-shipping-address-controller-v-2
   * @name CreateOrganisationShippingAddress1
   * @request POST:/api/v2/organisation/shipping-address
   */
  createOrganisationShippingAddress = (data: AddressRequest, params: RequestParams = {}) =>
    this.http.request<AddressResponse, any>({
      path: `/v2/organisation/shipping-address`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrganisationShippingAddressPath = '/v2/organisation/shipping-address'
  static createOrganisationShippingAddressMethod = 'POST'
}
